// picks an element from the passed array at random and returns it
export function pickRandom(array) {
    return array[Math.floor(Math.random() * array.length)];
}

export function getRand(min, max) {
    return Math.floor(Math.random() * max) + min;
}

export const camelCaseToRegular = (str) => {
    // insert a space before all caps
    return (
        str
            .replace(/([A-Z])/g, ' $1')
            // uppercase the first character
            .replace(/^./, function (str) {
                return str.toUpperCase();
            })
    );
};

// Internet Explorer 6-11
export const isIE = /*@cc_on!@*/ false || !!document.documentMode;

// Edge 20+
export const isEdge = !isIE && !!window.StyleMedia;

// Chrome 1 - 71
export const isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);

// Firefox 1.0+
export const isFirefox = typeof InstallTrigger !== 'undefined';

export const isIpad = navigator.userAgent.match(/iPad/i) != null;

export const studentGrade = (grade) => {
    return grade <= 2 ? 1 : grade <= 4 ? 2 : 3;
};
